import { Route } from 'react-router-dom';
import { lazyRoute } from '../lazyRoute';

// One small chunk (section.ts) for the whole module, staff and patient pages; screens split further inside
const Dental = lazyRoute(() => import('./section').then((m) => m.Dental));

/** Dental (today, patients, recall, treatment plans, reports, practice system, HIPAA, settings), under /agencies/:agencyId/dental */
export const dentalAgencyRoutes = <Route path="dental/*" element={<Dental />} />;

/** Patient-facing (no sign-in), all under /dental: book/:pageSlug, visit, insurance and plan (public/DentalPublic.tsx) */
export const dentalPublicRoutes = <Route path="/dental/*" element={<Dental />} />;
